const iso_639_1 = require('./data/iso_639-1');
const iso_639_2 = require('./data/iso_639-2');

module.exports = {
  iso_639_1,
  iso_639_2
};
